import { Card, Flex, Typography } from "antd";

import styles from "../PatientSnapshot.module.scss";

const { Text } = Typography;

interface LabelValueCardRow {
	label: string;
	value: React.ReactNode;
}

interface LabelValueCardProps {
	title: string;
	className?: string;
	rows: LabelValueCardRow[];
	variant?: "horizontal" | "vertical";
	rowClassName?: string;
	labelClassName?: string;
	valueClassName?: string;
	bold?: boolean;
	children?: React.ReactNode;
}

export const LabelValueCard = ({
	title,
	className,
	rows,
	variant = "horizontal",
	rowClassName,
	labelClassName,
	valueClassName,
	bold,
	children,
}: LabelValueCardProps) => (
	<Card title={title} size="small" className={className}>
		{rows.map((row) => (
			<Flex
				key={row.label}
				vertical={variant === "vertical"}
				justify={variant === "horizontal" ? "space-between" : undefined}
				align={variant === "horizontal" ? "center" : undefined}
				className={
					rowClassName ??
					(variant === "vertical" ? styles.medicalField : undefined)
				}
			>
				<Text
					className={
						labelClassName ??
						(variant === "vertical" ? styles.fieldLabel : undefined)
					}
				>
					{row.label}
				</Text>
				<Text
					strong={bold}
					className={
						valueClassName ??
						(variant === "vertical" ? styles.fieldValue : undefined)
					}
				>
					{row.value}
				</Text>
			</Flex>
		))}
		{children}
	</Card>
);
